import React from 'react';
import PropTypes from 'prop-types';
import LoginWrapper from '../LoginWrapper';

/**
 * Google LoginExample provider.
 */
const GoogleLogin = ({
  width, height, title, authorizationUrl, clientId, redirectUri,
  children, scope, provider, responseType, onCode,
}) => (
  <LoginWrapper
    width={width}
    height={height}
    title={title}
    authorizationUrl={authorizationUrl}
    clientId={clientId}
    redirectUri={redirectUri}
    scope={scope}
    provider={provider}
    responseType={responseType}
    onCode={onCode}
  >
    {children}
  </LoginWrapper>
);

/**
 * Define the default props to open the dialog authorization.
 */
GoogleLogin.defaultProps = {
  width: 450,
  height: undefined,
  title: '',
  scope: 'profile email',
  provider: 'google',
  authorizationUrl: 'https://accounts.google.com/o/oauth2/auth',
  redirectUri: undefined,
  children: undefined,
};

/**
 * Available props to use on component render.
 */
GoogleLogin.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  title: PropTypes.string,
  scope: PropTypes.string,
  authorizationUrl: PropTypes.string,
  redirectUri: PropTypes.string,
  provider: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  responseType: PropTypes.string.isRequired,
  onCode: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default GoogleLogin;
